import * as React from 'react';
import { createSvg } from '../../utils/createSvg';
export var Plus = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M28 16a1 1 0 0 1-1 1H17v10a1 1 0 1 1-2 0V17H5a1 1 0 1 1 0-2h10V5a1 1 0 1 1 2 0v10h10a1 1 0 0 1 1 1" })), '0 0 32 32', 'Plus');
//# sourceMappingURL=Plus.js.map